import {
  branch_category_overall,
  branch_category_cluster,
  branch_category_area,
  branch_category_branch,
} from "../../services/reports/branch_category_service";
import { actionTypes } from "../action_types";

const getBranchCategory = (fetchFunction, type) => (data) => (dispatch) => {
  return fetchFunction(data).then((resp) => {
    if (resp.problem === null) {
      dispatch({
        type,
        payload: resp.data !== null ? resp.data : { branchCategories: [] },
      });
    }
    return Promise.resolve(resp);
  });
};

export const GetBranchCategoryOverall = getBranchCategory(
  branch_category_overall,
  actionTypes.REPORTS_BRANCHCATEGORY_GET_OVERALL
);

export const GetBranchCategoryCluster = getBranchCategory(
  branch_category_cluster,
  actionTypes.REPORTS_BRANCHCATEGORY_GET_CLUSTER
);

export const GetBranchCategoryArea = getBranchCategory(
  branch_category_area,
  actionTypes.REPORTS_BRANCHCATEGORY_GET_AREA
);

export const GetBranchCategoryBranch = getBranchCategory(
  branch_category_branch,
  actionTypes.REPORTS_BRANCHCATEGORY_GET_BRANCH
);
